<template>
    <span>
        <CountUp :key="options.decimalPlaces" :endVal="total" :options="options"></CountUp>
        {{ currencySymbol }}
    </span>
</template>

<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";

export default {
    name: "TotalPrice",
    mixins: [registrationPriceMixin],
    data() {
        return {
            startVal: 0
        }
    },
    computed: {
        total() {
            return this.getInvoiceTotal - this.getCouponTotal
        },
        options() {
            return {
                useEasing: true,
                useGrouping: true,
                separator: '.',
                decimal: ',',
                decimalPlaces: this.total % 1 !== 0 ? 2 : 0,
                duration: 0.7,
                startVal: this.startVal
            }
        }
    },
    watch: {
        total(newValue, oldValue) {
            this.startVal = oldValue
        }
    }
}
</script>

<style scoped>

</style>
